import { openModal } from 'components/Modal';

import { PRICE_SUBMIT_ERROR_MODAL_NAME } from './PriceSubmitErrorModal';

export function getNotListedOnline(formValues, { useLegacyCheckbox = false, hasFileProof = false } = {}) {
  if (useLegacyCheckbox) return !!formValues.notListedOnline;
  // A file proof counts as "listed": without this, the error modal shows the
  // "prices not listed online" copy to partners who did provide proof.
  if (hasFileProof) return false;
  return !(formValues.linkToPrice && formValues.linkToPrice.trim() !== '');
}

export function openPriceSubmitErrorModal(
  dispatch,
  { currencyCode, serviceName, linkToPrice, servicePrice, notListedOnline }
) {
  dispatch(
    openModal(PRICE_SUBMIT_ERROR_MODAL_NAME, {
      currencyCode,
      serviceName,
      linkToPrice,
      servicePrice,
      notListedOnline,
    })
  );
}
